<template>
  <v-row style="padding-left: 0px;">
    <v-flex pt-1 pb-2 pl-2 pr-4 shrink>
      <h3>Repeat Services</h3>
    </v-flex>
      <v-flex pb-2 shrink>
        <v-row align="center">
          <v-flex pr-4><v-checkbox hide-details @change="change" v-model="query.includeCancelled" label="Show Hidden"></v-checkbox></v-flex>
          <v-flex><v-text-field style="padding-top: 0px !important" hide-details placeholder="Query" v-model="query.query" /></v-flex>
          <v-flex pl-2 pr-2><v-btn @click="change" x-small dark class="text-none">Search</v-btn></v-flex>
          <v-flex><v-btn @click="createRepeatService" x-small color="blue" dark class="text-none">New Service</v-btn></v-flex>
        </v-row>
    </v-flex>
  </v-row>
</template>

<script>
export default {
  name: "repeat_service_search_box",
  props: {
    query: Object,
  },
  data: function () {
    return {};
  },
  methods: {
    createRepeatService: function () {
      this.$emit("createRepeatService", null);
    },
    change: function () {
      this.$emit("changeQuery", null);
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}
</style>
